export var fonts = {
  primary: 'var(--wcds-font-primary)',
  secondary: 'var(--wcds-font-secondary)',
  arabic: 'var(--wcds-font-arabic)',
  japanese: 'var(--wcds-font-japanese)'
};